import React from 'react';
import styled from 'styled-components';

import theme from '../../../styles/theme';
import PlayButton from '../svgs/PlayButton';

const { colors } = theme;

const PlayButtonWrapper = styled.div`
    background-color: ${props => props.transparent ? "transparent" : props.color};
    border-color: ${props => props.color};
    border-style: ${props => props.transparent && 'solid'};
    border-width: ${props => props.transparent && '2px'};
    width: ${props => props.width ? props.width : 60}px;
    height: ${props => props.width ? props.width : 60}px;
    border-radius: ${props => props.radius ? props.radius : 50}%;
    transition: background-color 1s ease;

    svg {
        fill: ${props => props.transparent ? props.color : colors.white};
        width: 100%;
        height: 100%;
    }

    :hover {
        background-color: ${colors.primary.dark};
    }
`;
 
const BasicPlayButton = ({ color, width, radius, transparent, className }) => {
    return (
        <PlayButtonWrapper
            transparent={transparent}
            color={color ? color : colors.brandMain}
            width={width}
            radius={radius}
            className={`play-button__wrapper ${className}`}
        >
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
		    <circle cx="30" cy="30" r="30" fill="none" />
            <path d="M40.6155 29.7692L24.6924 41.9602L24.6924 17.5782L40.6155 29.7692Z" />
        </svg>
        </PlayButtonWrapper>
    )
}
 
export default BasicPlayButton;